import { Component } from "@angular/core";

@Component({
  selector: 'app-se-reporting-shell',
  templateUrl: './shell.component.html'
})
export class ShellComponent {
  title = 'Enterprise Reporting'
}